import { Component } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { RadioGroupItemComponent } from '../item/radio-group-item.component';

@Component({
    selector: 'radio-group-item2',
    templateUrl: 'radio-group-item2.html',
    styleUrls: ['radio-group-item2.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class RadioGroupItem2Component<T = any> extends RadioGroupItemComponent<T> {}
